export default __webpack_public_path__ + "static/media/rank-3.39a049f1.svg";